/**
 * RadialClock.js
 *
 * @class   RadialClock
 * @author  Dan Goldshlack
 *
 */

import React from 'react';
import D3 from 'd3';

export default React.createClass({

	displayName: 'RadialClock',

	propTypes: {

	},

	render() {

		return <h3>Radial Clock</h3>

	}

});



/** WEBPACK FOOTER **
 ** ./src/charts/radial-clock/RadialClock.js
 **/